import React, {useRef, useEffect} from "react";
import EditorNumber from "../numbers/EditorNumber";
import GameType from "../../data/GameType";
import { useTranslation } from "react-i18next";

const LottoRowEditor = (props) => {
    const { t } = useTranslation();
    const element = useRef();
    const isBingo = () => {
        return props.gameType.name === GameType.BINGO.name;
    }
    const isKeno = () => {
        return props.gameType.name === GameType.KENO.name;
    }
    useEffect(() => {
        if (isBingo()) {
            return;
        }
        var scrollTo = element.current.offsetTop -  50
        window.scrollTo({
            top: scrollTo,
            behavior: "smooth"
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const createNumbers = (selected, nrType) => {
        var numbers = [];
        var selectableNumbers;
        if (isBingo()) {
            selectableNumbers = props.selectableNumbers;
        } else {
            selectableNumbers = props.gameType[nrType + "Numbers"];
        }
        for (var i = selectableNumbers[0]; i <= selectableNumbers[1]; i++) {
            numbers.push(
            <EditorNumber 
                className="square"
                key={i}
                selected={selected.includes(i)}
                onClickNumber={(number) => props.onClickNumber(number, nrType)}
                number={i}
            ></EditorNumber>
            );
        }
        return numbers;
    };
    const getMainNumbers = () => {
        if (isBingo()) {
            return props.row.numbers[props.column];
        } else {
            return props.row.main;
        }
    };
    const getUnfilledCount = (max, numbers) => {
        return max - numbers.length;
    };
    const getUnfilledText = (max, numbers) => {
        return t('texts.chooseNumbers') + ' - ' + getUnfilledCount(max, numbers) + ' ' + t('texts.more');
    };
    const createExtraNumbers = () => {
        return (
            <div>
                <div className="inlineFlex marginTop1">{getUnfilledText(props.gameType.extraMax, props.row.extra)}</div>
                <div className="grid5">{createNumbers(props.row.extra, "extra")}</div>
            </div>
        );
    };
    return (
        <div ref={element} className={props.className || ""}>
            {!isBingo() && <div className="inlineFlex marginTop1">{getUnfilledText(isKeno() ? props.kenoCount : props.gameType.mainMax, getMainNumbers())}</div>}
            <div className="grid5">{createNumbers(getMainNumbers(), "main")}</div>
            {props.gameType.extraMax && createExtraNumbers()}
        </div>
    );
};

export default LottoRowEditor;